import { getAuthToken } from "@/lib/auth/authService";

export type UserProfileData = {
  profile: {
    tenantKey: string;
    userId: number;
    identityId: string;
    applicationRoleName: string;
    displayName: string;
    email: string;
  };
  features: ReadonlyArray<{ name: string; isActive: boolean }>;
  permissions: readonly string[];
};

export type UserProfileResponse = {
  data: UserProfileData;
};

export async function getUserProfile(): Promise<UserProfileResponse> {
  const token = getAuthToken();
  if (!token) throw new Error("No auth token available");

  const baseUrl = (
    window.APP_CONFIG?.PUBLIC_APIM_BASE_URL || "https://dev-apim.andor.app"
  ).replace(/\/$/, "");

  const response = await fetch(`${baseUrl}/api/user/profile`, {
    headers: { Authorization: `Bearer ${token}` },
    cache: "no-store",
  });

  if (!response.ok) {
    const err = new Error(`Profile failed (${response.status})`) as Error & {
      status?: number;
    };
    err.status = response.status;
    throw err;
  }

  return (await response.json()) as UserProfileResponse;
}
